import { render } from "./BasketModel.vue?vue&type=template&id=93d0c5ca&scoped=true"
import script from "./BasketModel.vue?vue&type=script&lang=js"
export * from "./BasketModel.vue?vue&type=script&lang=js"

import "./BasketModel.vue?vue&type=style&index=0&id=93d0c5ca&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1732715967/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d0c5ca"]])

export default __exports__